import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HoldersComponent } from '../pages/holders.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { ApiCore, ApiPoseedores, ApiDocum } from 'api-rest';
import {
  NgbPaginationModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { EmpusaSpinnerComponent } from '@empusa/empusa-core';
import { GeTableComponent } from '../share/components/ge-table.component';
import { GetAttributePipe } from '../share/components/pipe/get-attribute.pipe';
import { GeSelectPaginationComponent } from '../share/components/ge-select-pagination/ge-select-pagination.component';
import { HoldersSearchComponent } from '../pages/components-holders/holders-search/holders-search.component';
import { HoldersDetailComponent } from '../pages/components-holders/holders-detail/holders-detail.component';
import { WasteManagersSearchComponent } from '../pages/components-managers/waste-managers-search/waste-managers-search.component';
import { HoldersDetailGeneralDataComponent } from '../pages/components-holders/holders-detail-general-data/holders-detail-general-data.component';
import { HoldersDetailContactDataComponent } from '../pages/components-holders/holders-detail-contact-data/holders-detail-contact-data.component';
import { HoldersDetailAddressComponent } from '../pages/components-holders/holders-detail-address/holders-detail-address.component';
import { CustomDatePickerModule } from './custom-date-picker.module';
import { HoldersDetailDocumentsComponent } from '../pages/components-holders/holders-detail-documents/holders-detail-documents.component';
import { HoldersContactDialogComponent } from '../pages/components-holders/holders-contact-dialog/holders-contact-dialog.component';
import { HoldersAddressDialogComponent } from '../pages/components-holders/holders-address-dialog/holders-address-dialog.component';
import { HoldersWasteForecastComponent } from '../pages/components-holders/holders-waste-forecast/holders-waste-forecast.component';
import { HoldersContributionsDisComponent } from '../pages/components-holders/holders-contributions-dis/holders-contributions-dis.component';
import { HoldersContributionsDisDialogComponent } from '../pages/components-holders/holders-contributions-dis-dialog/holders-contributions-dis-dialog.component';
import { HoldersSelfInvoicesSearchComponent } from '../pages/components-holders/holders-self-invoices-search/holders-self-invoices-search.component';
import { HoldersUploadProductionNumComponent } from '../pages/components-holders/holders-upload-production-num/holders-upload-production-num.component';
import { WasteManagersDetailComponent } from '../pages/components-managers/waste-managers-detail/waste-managers-detail.component';
import { WasteManagersDetailAddressComponent } from '../pages/components-managers/waste-managers-detail-address/waste-managers-detail-address.component';
import { WasteManagersDetailAuthorizedWasteComponent } from '../pages/components-managers/waste-managers-detail-authorized-waste/waste-managers-detail-authorized-waste.component';
import { WasteManagersDetailContactDataComponent } from '../pages/components-managers/waste-managers-detail-contact-data/waste-managers-detail-contact-data.component';
import { WasteManagersDetailGeneralDataComponent } from '../pages/components-managers/waste-managers-detail-general-data/waste-managers-detail-general-data.component';
import { WasteManagersDetailDocumentComponent } from '../pages/components-managers/waste-managers-detail-document/waste-managers-detail-document.component';
import { WasteManagersDetailPackageReconditioningComponent } from '../pages/components-managers/waste-managers-detail-package-reconditioning/waste-managers-detail-package-reconditioning.component';
import { WasteManagersAddressDialogComponent } from '../pages/components-managers/waste-managers-address-dialog/waste-managers-address-dialog.component';
import { WasteManagersContactDialogComponent } from '../pages/components-managers/waste-managers-contact-dialog/waste-managers-contact-dialog.component';
import { WasteManagersDetailDocumentDialogComponent } from '../pages/components-managers/waste-managers-detail-document-dialog/waste-managers-detail-document-dialog.component';
import { HoldersNewDocumentDialogComponent } from '../pages/components-holders/holders-new-document-dialog/holders-new-document-dialog.component';
import { HoldersInvoiceNewDocumentDialogComponent } from '../pages/components-holders/holders-invoice-document-dialog/holders-invoice-document-dialog.component';
import { HoldersCvfInvoiceNewDocumentDialogComponent } from '../pages/components-holders/holders-cvf-invoice-new-document-dialog/holders-cvf-invoice-new-document-dialog.component';
import { HoldersManagerSelectionDialogComponent } from '../pages/components-holders/holders-manager-selection-dialog/holders-manager-selection-dialog.component';
import { WasteManagersAuthorizedDownDialogComponent } from '../pages/components-managers/waste-managers-authorized-down-dialog/waste-managers-authorized-down-dialog.component';
import { WasteManagersDetailPackageDownDialogComponent } from '../pages/components-managers/waste-managers-detail-package-down-dialog/waste-managers-detail-package-down-dialog.component';
import { HoldersContributionsDisDeclineDialogComponent } from '../pages/components-holders/holders-contributions-dis-cancel-dialog/holders-contributions-dis-cancel-dialog.component';
import { HoldersInvoiceRejectDialogComponent } from '../pages/components-holders/holders-invoice-reject-dialog/holders-invoice-reject-dialog.component';
import { HoldersSelfInvoicesCancelRevisionDialogComponent } from '../pages/components-holders/holders-self-invoices-cancel-revision-dialog/holders-self-invoices-cancel-revision-dialog.component';
import { HoldersCvfInvoiceRejectDialogComponent } from '../pages/components-holders/holders-cvf-invoice-reject-dialog/holders-cvf-invoice-reject-dialog.component';
import { WasteManagersPackageReconditioningUploadDialogComponent } from '../pages/components-managers/waste-managers-package-reconditioning-upload-dialog/waste-managers-package-reconditioning-upload-dialog.component';
import { HoldersInvoiceAccountingDialogComponent } from '../pages/components-holders/holders-invoice-accounting-dialog/holders-invoice-accounting-dialog.component';
import { DecimalNumberDirective } from '../share/components/utils/DecimalNumberDirective.directive';
import { TwoDigitDecimalNumberDirective } from "../share/components/utils/TwoDigitDecimalNumberDirective.directive";
import { FourDigitDecimalNumberDirective } from '../share/components/utils/FourDigitDecimalNumberDirective.directive';
import {
  ManagersRegisteredSearchComponent
} from "../pages/managers-registered-search/managers-registered-search.component";
import { WasteManagerAuthorizedUploadDialogComponent } from '../pages/components-managers/waste-managers-authorized-upload-dialog/waste-managers-authorized-upload-dialog.component';
import { HoldersContributionsDisImageDialogComponent } from '../pages/components-holders/holders-contributions-dis-image-dialog/holders-contributions-dis-image-dialog.component';
import { HoldersContributionsDisUploadDialogComponent } from '../pages/components-holders/holders-contributions-dis-upload-dialog/holders-contributions-dis-upload-dialog.component';
import { HoldersSelfInvoicesDialogComponent } from '../pages/components-holders/holders-self-invoices-dialog/holders-self-invoices-dialog.component';
import { HoldersContributionsDisPreviewDialogComponent } from '../pages/components-holders/holders-contributions-dis-preview-dialog/holders-contributions-dis-preview-dialog.component';
import { HoldersCvfSearchComponent } from '../pages/components-holders/holders-cvf-search/holders-cvf-search.component';
import { HoldersCvfDetailComponent } from '../pages/components-holders/holders-cvf-detail/holders-cvf-detail.component';
import { HoldersCvfMaterialDialogComponent } from '../pages/components-holders/holders-cvf-material-dialog/holders-cvf-material-dialog.component';
import { HoldersCvfRejectDialogComponent } from '../pages/components-holders/holders-cvf-reject-dialog/holders-cvf-reject-dialog.component';
import { HoldersCvfInvoicesSearchComponent } from '../pages/components-holders/holders-cvf-invoices-search/holders-cvf-invoices-search.component';
import { HoldersCvfInvoicesDialogComponent } from '../pages/components-holders/holders-cvf-invoices-dialog/holders-cvf-invoices-dialog.component';
import { HoldersCvfSignedUploadDialogComponent } from '../pages/components-holders/holders-cvf-signed-upload-dialog/holders-cvf-signed-upload-dialog.component';
import { HoldersCvfImageDetailComponent } from '../pages/components-holders/holders-cvf-image-detail/holders-cvf-image-detail.component';
import { HoldersWasteForecastDuplicateDialogComponent } from '../pages/components-holders/holders-waste-forecast-duplicate-dialog/holders-waste-forecast-duplicate-dialog.component';
import { HoldersStatusChangeDialogComponent } from '../pages/components-holders/holders-status-change-dialog/holders-status-change-dialog.component';
import { HoldersBajaMotivoDialogComponent } from '../pages/components-holders/holders-baja-motivo-dialog/holders-baja-motivo-dialog.component';
import { WasteManagersStatusChangeDialogComponent } from '../pages/components-managers/waste-managers-status-change-dialog/waste-managers-status-change-dialog.component';
import { WasteManagersBajaMotivoDialogComponent } from '../pages/components-managers/waste-managers-baja-motivo-dialog/waste-managers-baja-motivo-dialog.component';

export const CoreConfigFactory = () =>
  new ApiCore.Configuration(<ApiCore.ConfigurationParameters>{});

export const CoreBasePathFactory = (environment: any) => {
  console.log('USANDO URL DE CORE ' + environment.urlBackCore);
  const basePath = environment.urlBackCore;
  return basePath?.endsWith('/') ? basePath.slice(0, -1) : basePath;
};

export const PoseedoresConfigFactory = () =>
  new ApiPoseedores.Configuration(<ApiPoseedores.ConfigurationParameters>{});

export const PoseedoresBasePathFactory = (environment: any) => {
  console.log('USANDO URL DE POSEEDORES ' + environment.urlBackPoseedores);
  const basePath = environment.urlBackPoseedores;
  return basePath?.endsWith('/') ? basePath.slice(0, -1) : basePath;
};

export const DocumConfigFactory = () =>
  new ApiDocum.Configuration(<ApiDocum.ConfigurationParameters>{});

export const DocumBasePathFactory = (environment: any) => {
  console.log('USANDO URL DE DOCUM ' + environment.urlBackDocum);
  const basePath = environment.urlBackDocum;
  return basePath?.endsWith('/') ? basePath.slice(0, -1) : basePath;
};

export const explorerRoutes = [
  {
    path: '',
    component: HoldersComponent,
    children: [
      { path: 'search', component: HoldersSearchComponent },
      { path: 'detail/:id', component: HoldersDetailComponent },
      {
        path: 'waste-managers-detail/:id',
        component: WasteManagersDetailComponent,
      },
      {
        path: 'waste-managers-search',
        component: WasteManagersSearchComponent,
      },
      {
        path: 'contributions-dis-search',
        component: HoldersContributionsDisComponent,
      },
      {
        path: 'invoices-search',
        component: HoldersSelfInvoicesSearchComponent,
      },
      {
        path: 'managers-registered-search',
        component: ManagersRegisteredSearchComponent,
      },
      {
        path: 'holders-cvf-search',
        component: HoldersCvfSearchComponent
      },
      {
        path: 'holders-cvf-detail/:id',
        component: HoldersCvfDetailComponent
      },
      {
        path: 'holders-cvf-detail/:id',
        component: HoldersCvfDetailComponent
      },
      {
        path: 'holders-cvf-invoices-search',
        component: HoldersCvfInvoicesSearchComponent
      },
            {
        path: 'holders-cvf-invoices-detail/:id',
        component: HoldersCvfInvoicesDialogComponent
      },
    ],
  },
];

@NgModule({
  declarations: [
    HoldersComponent,
    HoldersSearchComponent,
    HoldersDetailComponent,
    HoldersDetailGeneralDataComponent,
    HoldersDetailContactDataComponent,
    HoldersDetailAddressComponent,
    HoldersDetailDocumentsComponent,
    HoldersWasteForecastComponent,
    HoldersContactDialogComponent,
    HoldersAddressDialogComponent,
    HoldersNewDocumentDialogComponent,
    GeTableComponent,
    GetAttributePipe,
    GeSelectPaginationComponent,
    WasteManagersSearchComponent,
    HoldersContributionsDisComponent,
    HoldersContributionsDisDialogComponent,
    HoldersSelfInvoicesSearchComponent,
    HoldersInvoiceNewDocumentDialogComponent,
    HoldersCvfInvoiceNewDocumentDialogComponent,
    HoldersUploadProductionNumComponent,
    WasteManagersDetailComponent,
    WasteManagersDetailAddressComponent,
    WasteManagersDetailAuthorizedWasteComponent,
    WasteManagersDetailContactDataComponent,
    WasteManagersDetailGeneralDataComponent,
    WasteManagersDetailDocumentComponent,
    WasteManagersAddressDialogComponent,
    WasteManagersDetailPackageReconditioningComponent,
    WasteManagersContactDialogComponent,
    WasteManagersDetailDocumentDialogComponent,
    WasteManagersAuthorizedDownDialogComponent,
    HoldersManagerSelectionDialogComponent,
    WasteManagersDetailPackageDownDialogComponent,
    DecimalNumberDirective,
    TwoDigitDecimalNumberDirective,
    FourDigitDecimalNumberDirective,
    WasteManagerAuthorizedUploadDialogComponent,
    ManagersRegisteredSearchComponent,
    WasteManagersPackageReconditioningUploadDialogComponent,
    HoldersContributionsDisImageDialogComponent,
    HoldersInvoiceRejectDialogComponent,
    HoldersSelfInvoicesCancelRevisionDialogComponent,
    HoldersCvfInvoiceRejectDialogComponent,
    HoldersContributionsDisPreviewDialogComponent,
    HoldersContributionsDisDeclineDialogComponent,
    HoldersSelfInvoicesDialogComponent,
    HoldersInvoiceAccountingDialogComponent,
    HoldersContributionsDisUploadDialogComponent,
    HoldersCvfSearchComponent,
    HoldersCvfDetailComponent,
    HoldersCvfMaterialDialogComponent,
    HoldersCvfRejectDialogComponent,
    HoldersCvfInvoicesSearchComponent,
    HoldersCvfInvoicesDialogComponent,
    HoldersCvfSignedUploadDialogComponent,
    HoldersCvfImageDetailComponent,
    HoldersWasteForecastDuplicateDialogComponent,
    HoldersStatusChangeDialogComponent,
    HoldersBajaMotivoDialogComponent,
    WasteManagersStatusChangeDialogComponent,
    WasteManagersBajaMotivoDialogComponent,
  ],
  imports: [
    NgbTooltipModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgSelectModule,
    CommonModule,
    // ApiPoseedores.ApiModule.forRoot(PoseedoresConfigFactory),
    ApiDocum.ApiModule.forRoot(DocumConfigFactory),
    RouterModule.forChild(explorerRoutes),

    MaterialModule,
    EmpusaSpinnerComponent,
    CustomDatePickerModule,
  ],
  exports: [HoldersComponent],
  providers: [
    DatePipe,
    {
      provide: ApiPoseedores.BASE_PATH,
      useFactory: PoseedoresBasePathFactory,
      deps: ['environment'],
    },
    {
      provide: ApiDocum.BASE_PATH,
      useFactory: DocumBasePathFactory,
      deps: ['environment'],
    },
  ],
})
export class HoldersHomeModule {
  constructor() {
    let compilationVersion = '0.0.1-R->04/10/23-12:14:49';
    console.log('Home version:' + compilationVersion);
  }
}
